// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"7cb95697","268":"05b0d5aa","382":"5626c7bc","457":"95130d01","551":"cfde9034"}[chunkId] + ".chunk.js";
};